// signalrService.ts
import * as signalR from "@microsoft/signalr";

let connection: signalR.HubConnection | null = null;

export const startSignalRConnection = async (hubUrl: string) => {
  if (connection && connection.state === signalR.HubConnectionState.Connected) {
    return connection;
  }

  if (!connection) {
    connection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl, {
        accessTokenFactory: async () => "", // Add token if required
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();
  }

  if (connection.state === signalR.HubConnectionState.Disconnected) {
    try {
      await connection.start();
      console.info("✅ SignalR Connected");
    } catch (err) {
      console.error("❌ SignalR Connection failed: ", err);
      setTimeout(() => startSignalRConnection(hubUrl), 5000);
    }
  }

  return connection;
};

export const getSignalRConnection = () => connection;

export const stopSignalRConnection = async () => {
  if (connection) {
    await connection.stop();
    connection = null;
    console.warn("❌ SignalR Disconnected");
  }
};
